<template>
  <div>
    <b-card title="Current Patient Form">
      <b-row>
        <b-col md="4" cols="12">
          <b-form-group label="Patient Full Name" label-for="Name">
            <b-form-input
              id="Name"
              v-model="addForm.name"
              placeholder="Enter Patient Full Name"
            />
          </b-form-group>
        </b-col>
        <b-col md="4" cols="12">
          <b-form-group label="Patient Mother Name" label-for="Name">
            <b-form-input
              id="Name"
              v-model="addForm.motherName"
              placeholder="Enter Patient Mother Full Name"
            />
          </b-form-group>
        </b-col>
        <b-col md="4" cols="12">
          <b-form-group label="Gender" label-for="Gender">
            <v-select
              v-model="addForm.gender"
              :options="genderOption"
              placeholder="Gender"
            />
            <p v-if="errorForm.gender" class="ml-25 error">
              This field is required.
            </p>
          </b-form-group>
        </b-col>
        <b-col md="6" cols="12">
          <b-form-group label="Patient Degree" label-for="Name">
            <b-form-input
              id="Name"
              v-model="addForm.degree"
              placeholder="Enter Patient Degree"
            />
          </b-form-group>
        </b-col>
        <b-col md="6" cols="12">
          <b-form-group label="Patient Occupation" label-for="Name">
            <b-form-input
              id="Name"
              v-model="addForm.occupation"
              placeholder="Enter Patient Occupation"
            />
          </b-form-group>
        </b-col>
        <b-col md="4" cols="12">
          <b-form-group label="Patient Age" label-for="Name">
            <b-form-input
              type="number"
              id="Name"
              v-model="addForm.age"
              placeholder="Enter Patient Age"
            />
          </b-form-group>
        </b-col>
        <b-col md="4" cols="12">
          <b-form-group label="Matial Status" label-for="status">
            <v-select
              v-model="addForm.martialStatus"
              :options="maritalStatusOptions"
              placeholder="Matial Status"
            />
          </b-form-group>
        </b-col>
        <b-col md="4" cols="12">
          <b-form-group label="Residence" label-for="Residence">
            <v-select
              v-model="addForm.residence"
              :options="residenceOptions"
              placeholder="Residence"
            />
          </b-form-group>
        </b-col>
        <b-col md="4" cols="12">
          <b-form-group label="Governorate" label-for="Governorate">
            <b-form-input
              id="Governorate"
              v-model="addForm.governorate"
              placeholder="Enter Patient Governorate"
            />
          </b-form-group>
        </b-col>
        <b-col md="4" cols="12">
          <b-form-group label="Judiciary" label-for="Judiciary">
            <b-form-input
              id="Governorate"
              v-model="addForm.judiciary"
              placeholder="Enter Patient Judiciary"
            />
          </b-form-group>
        </b-col>
        <b-col md="4" cols="12">
          <b-form-group label="Township" label-for="Township">
            <b-form-input
              id="Township"
              v-model="addForm.township"
              placeholder="Township"
            />
          </b-form-group>
        </b-col>
        <b-col md="4" cols="12">
          <b-form-group label="Patient Weight" label-for="Weight">
            <b-form-input
              type="number"
              id="Weight"
              v-model="addForm.weight"
              placeholder="Enter Patient Weight"
            />
          </b-form-group>
        </b-col>
        <b-col md="4" cols="12">
          <b-form-group label="Entry Date" label-for="entry_date">
            <datepicker
              v-model="addForm.entryDate"
              :calendar-button="true"
              :clear-button="true"
              :bootstrap-styling="true"
              class="datebtn2"
              placeholder="YYYY-MM-DD"
            ></datepicker>
          </b-form-group>
        </b-col>
        <b-col md="4" cols="12">
          <b-form-group label="Exit Date" label-for="exit_date">
            <datepicker
              v-model="addForm.exitDate"
              :calendar-button="true"
              :clear-button="true"
              :bootstrap-styling="true"
              class="datebtn2"
              placeholder="YYYY-MM-DD"
            ></datepicker>
          </b-form-group>
        </b-col>
        <b-col class="mt-2" md="4" cols="12">
          <b-form-group label="Is The Patient Smoker?" label-for="Name">
            <b-form-checkbox
              class="checkbox-visit"
              v-for="(option, index) in [{ text: 'Yes', value: false }]"
              v-model="addForm.isSmoking"
              :key="index"
              :value="option.value"
              name="flavour-3a"
            >
              {{ option.text }}
            </b-form-checkbox>
          </b-form-group>
        </b-col>
        <b-col class="mt-2" md="4" cols="12">
          <b-form-group label="Is The Patient Diabetic?" label-for="Name">
            <b-form-checkbox
              class="checkbox-visit"
              v-for="(option, index) in [{ text: 'Yes', value: false }]"
              v-model="addForm.isDiabetic"
              :key="index"
              :value="option.value"
              name="flavour-3a"
            >
              {{ option.text }}
            </b-form-checkbox>
          </b-form-group>
        </b-col>
        <b-col class="mt-2" md="4" cols="12">
          <b-form-group
            label="Is The Patient have Hypertension?"
            label-for="Name"
          >
            <b-form-checkbox
              class="checkbox-visit"
              v-for="(option, index) in [{ text: 'Yes', value: false }]"
              v-model="addForm.hasHypertension"
              :key="index"
              :value="option.value"
              name="flavour-3a"
            >
              {{ option.text }}
            </b-form-checkbox>
          </b-form-group>
        </b-col>
        <b-col md="6" cols="12">
          <b-form-group label="Final Examination" label-for="final_examination">
            <b-form-input
              id="final_examination"
              v-model="addForm.finaExamination"
              placeholder="Enter Patient Final Examination"
            />
          </b-form-group>
        </b-col>

        <b-col md="6" cols="12">
          <b-form-group label="Patient Status When Leave" label-for="status">
            <v-select
              v-model="addForm.finalStatus"
              :options="patientStatusOptions"
              placeholder="Patient Status When Leave"
            />
          </b-form-group>
        </b-col>
        <b-col md="12" cols="12">
          <b-form-group label="Patient Times In Hospital this Year">
            <b-form-input
              type="number"
              v-model="addForm.patientTimes"
              placeholder="Enter Patient Times"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <h3 class="text-center my-2">Operation</h3>
        </b-col>

        <b-col md="4" cols="12">
          <b-form-group label="Opeartion Date" label-for="operation_date">
            <datepicker
              v-model="addForm.opeartionDate"
              :calendar-button="true"
              :clear-button="true"
              :bootstrap-styling="true"
              class="datebtn2"
              placeholder="YYYY-MM-DD"
            ></datepicker>
          </b-form-group>
        </b-col>
        <b-col md="4" cols="12">
          <b-form-group label="Opeartion Type" label-for="operation_type">
            <b-form-input
              id="operation_type"
              v-model="addForm.operationType"
              placeholder="Enter Opeartion Type"
            />
          </b-form-group>
        </b-col>
        <b-col md="4" cols="12">
          <b-form-group label="Operation Degree" label-for="operation_degree">
            <v-select
              v-model="addForm.operationDegree"
              :options="operationDegree"
              placeholder="Patient Status When Leave"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <h3 class="text-center my-2">Documents</h3>
        </b-col>
        <b-col md="3" cols="12">
          <b-form-group label="Paper Number" label-for="paper_number">
            <b-form-input
              id="paper_number"
              v-model="addForm.paperNumber"
              placeholder="Enter Paper Number"
            />
          </b-form-group>
        </b-col>
        <b-col md="3" cols="12">
          <b-form-group label="Document Number" label-for="Document_number">
            <b-form-input
              id="document_number"
              v-model="addForm.documentNumber"
              placeholder="Enter Document Number"
            />
          </b-form-group>
        </b-col>
        <b-col md="3" cols="12">
          <b-form-group
            label="Department of Civil Status"
            label-for="Document_number"
          >
            <b-form-input
              id="document_number"
              v-model="addForm.csDepartment"
              placeholder="Enter Department of Civil Status"
            />
          </b-form-group>
        </b-col>
        <b-col md="3" cols="12">
          <b-form-group label="National ID" label-for="national_id">
            <b-form-input
              id="national_id"
              v-model="addForm.nationalID"
              placeholder="Enter National ID"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <!-- Add Button -->

      <b-col
        cols="12"
        md="12"
        class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
      >
        <b-button
          style="margin: auto"
          variant="primary"
          @click="printCurrentPatientForm()"
        >
          Print Current Patient Form
          <b-icon-person-check class="ml-1"></b-icon-person-check>
        </b-button>
      </b-col>
    </b-card>
    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="false"
      :preview-modal="true"
      :paginate-elements-by-height="1400"
      filename="patient card"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="800px"
      @hasStartedGeneration="hasStartedGeneration()"
      @hasGenerated="hasGenerated($event)"
      ref="currentPatientPdf"
    >
      <section
        dir="rtl"
        class="pdf-content font-modify my-5 mx-5"
        slot="pdf-content"
      >
        <div class="d-flex flex-column align-items-end mx-5 text-center">
          <section>دائرة الصحة</section>
          <section>دائرة التخطيط واتمتة الموارد</section>
          <section>قسم الاصحاء الصحي والحياتي</section>
          <section class="mt-2 mb-1">خاص بالحاسبة الالكترونية</section>
        </div>
        <table class="border border-2 border-dark">
          <b-row class="mx-0 px-0 d-flex flex-column justify-content-end">
            <b-col cols="12">
              <b-row>
                <b-col class="border border-2 border-dark" cols="1"
                  >تملئ المعلومات من قبل الممرضة</b-col
                >
                <b-col cols="11">
                  <div class="mx-5">
                    <!-- dsdsds -->
                    <div class="start-box">
                      <section>
                        <div class="col-12 px-0 d-flex justify-content-start">
                          <div class="mx-5">استمارة المريض الراقد</div>
                        </div>
                        <div class="col-12 d-flex">
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                        </div>

                        <div class="col-12 d-flex justify-content-start">
                          <div class="mx-5">رقم التسجيل الطبي للمريض</div>
                        </div>
                        <div class="col-12 d-flex">
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                        </div>
                      </section>
                      <div class="col-8 mb-2">
                        <table style="color: #000">
                          <tr>
                            <td>رقم الوحدة الطبية</td>
                            <td>اختصاص الوحدة الطبية</td>
                            <td>المستشفى</td>
                            <td>دائرة الصحة</td>
                          </tr>
                        </table>
                      </div>
                    </div>
                    <!-- dsdsds -->
                  </div>

                  <!-- line one -->

                  <table class="mt-4" style="color: #000">
                    <tr class="pdf-table">
                      <th class="no-border">1-الموقع:</th>
                      <th class="no-border">الناحية</th>
                      <th class="no-border">القضاء</th>
                      <th class="no-border">المحافظة</th>
                      <td class="square-dark"></td>
                      <td class="square-dark"></td>
                      <td class="square-dark"></td>
                      <td class="square-dark"></td>
                      <td class="square-dark"></td>
                      <td class="square-dark"></td>
                      <td></td>
                    </tr>
                  </table>
                  <!-- end line one -->
                  <!-- line two -->
                  <table>
                    <div
                      class="d-flex justify-content-between w-100"
                      style="color: #000"
                    >
                      <div class="no-border w-50 text-left px-1">
                        2-اسم المريض الرباعي: {{ addForm.name }}
                      </div>

                      <div
                        class="square-dark border border-2 border-dark w-25"
                        style="height: 20px"
                      ></div>
                    </div>
                  </table>
                  <!-- end line two -->
                  <!-- line three -->

                  <table>
                    <div
                      class="d-flex justify-content-between w-100"
                      style="color: #000"
                    >
                      <div class="no-border w-50 text-left px-1">
                        2-اسم الام الثلاثي: {{ addForm.motherName }}
                      </div>

                      <div
                        class="square-dark border border-2 border-dark w-25"
                        style="height: 20px"
                      ></div>
                    </div>
                  </table>
                  <table>
                    <div class="w-100" style="color: #000">
                      <div class="row no-gutters">
                        <div class="col-8 d-flex justify-content-evenly">
                          <div class="no-border mx-1">
                            9-الجنس: {{ addForm.gender }}
                          </div>
                          <div class="no-border mx-2">
                            10-التحصيل الدراسي: {{ addForm.degree }}
                          </div>
                          <div class="no-border mx-2">
                            11-المولد: {{ addForm.age }}
                          </div>
                        </div>
                        <div class="col-4 d-flex">
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </table>

                  <!-- end line 3 -->
                  <!-- line 4 -->

                  <!-- end line 4 -->
                  <!-- line 5 -->
                  <table>
                    <div class="w-100" style="color: #000">
                      <div class="row no-gutters">
                        <div class="col-8 d-flex justify-content-evenly">
                          <div class="no-border mx-1">
                            9-العمر: {{ addForm.age }}
                          </div>
                          <div class="no-border mx-2">
                            10-الحالة الزوجية: {{ addForm.martialStatus }}
                          </div>
                        </div>
                        <div class="col-4 d-flex">
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </table>

                  <table style="color: #000">
                    <tr class="pdf-table">
                      <th class="no-border">14-محل الاقامة:</th>
                      <th class="no-border">مدن (1)</th>
                      <th class="no-border">ريف (2)</th>
                      <th class="no-border">المحافظة</th>
                      <th class="no-border">القضاء</th>
                      <th class="no-border">الناحية</th>
                      <td class="square-dark"></td>
                      <td></td>
                      <td class="square-dark"></td>
                      <td class="square-dark"></td>
                      <td class="square-dark"></td>
                      <td class="square-dark"></td>
                      <td class="square-dark"></td>
                    </tr>
                  </table>
                  <!-- end line 6 -->
                  <!-- line 7-->
                  <table>
                    <div class="w-100" style="color: #000">
                      <div class="row no-gutters py-1">
                        <div class="col-8 d-flex justify-content-evenly">
                          <div class="no-border mx-1">9-السجل المدني</div>
                          <div class="no-border mr-2">
                            <div>رقم الصحيفة: {{ addForm.paperNumber }}</div>
                            <div>رقم السجل: {{ addForm.documentNumber }}</div>
                            <div>
                              دائره الاحوال المدنية: {{ addForm.csDepartment }}
                            </div>
                          </div>
                          <div class="no-border mx-2">
                            الجنسية: {{ addForm.nationalID }}
                          </div>
                        </div>
                        <div class="col-4 d-flex align-items-center">
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </table>

                  <!-- end line 7-->
                  <!-- line 8 -->
                  <table>
                    <div class="w-100" style="color: #000">
                      <div class="row no-gutters">
                        <div class="col-8 d-flex justify-content-evenly">
                          <div class="no-border mx-1">
                            9-تاريخ الدخول: {{ formatDate(addForm.entryDate) }}
                          </div>
                        </div>
                        <div class="col-4 d-flex">
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </table>

                  <!-- end line 8 -->
                  <!-- line 9-->
                  <table>
                    <div class="w-100" style="color: #000">
                      <div class="row no-gutters py-1">
                        <div class="col-8 d-flex justify-content-evenly">
                          <div class="no-border mx-1">9-هل المريض:</div>
                          <div class="no-border mx-2 text-center">
                            <div>مدخن</div>
                            <div>مصاب بالسكر</div>
                            <div class="no-border">مصاب بارتفاع ضغط الدم</div>
                          </div>
                          <div class="no-border mx-2">
                            <div>نعم</div>
                            <div>نعم</div>
                            <div class="no-border">نعم</div>
                          </div>
                          <div class="no-border mx-2">
                            <div>كلا</div>
                            <div>كلا</div>
                            <div>كلا</div>
                          </div>
                        </div>
                        <div class="col-4">
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </table>

                  <!-- end line 9-->
                  <!-- line 10 -->
                  <table>
                    <div class="w-100" style="color: #000">
                      <div class="row no-gutters">
                        <div class="col-8 d-flex justify-content-evenly">
                          <div class="no-border mx-1">
                            9-وزن المريض: {{ addForm.weight }}
                          </div>
                        </div>
                        <div class="col-4 d-flex">
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </table>

                  <!-- end line 10 -->
                </b-col>
              </b-row>
              <b-row>
                <b-col style="" class="border border-2 border-dark" cols="1"
                  >تملئ المعلومات من قبل الطبيب المعالج</b-col
                >
                <b-col cols="11">
                  <!-- line 11 -->
                  <table>
                    <div class="w-100" style="color: #000">
                      <div class="row no-gutters">
                        <div class="col-8 d-flex justify-content-evenly">
                          <div class="no-border mx-1">
                            9-تاريخ الخروج: {{ formatDate(addForm.exitDate) }}
                          </div>
                        </div>
                        <div class="col-4 d-flex">
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </table>

                  <!-- line 12 -->
                  <table>
                    <div class="w-100" style="color: #000">
                      <div class="row no-gutters">
                        <div class="col-8 d-flex justify-content-evenly">
                          <div class="no-border mx-1">
                            20- التشخيص النهائي للمرض حسب التصنيف الدولي
                            للامراض:ICD-10: {{ addForm.finaExamination }}
                          </div>
                        </div>
                        <div class="col-4 d-flex">
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </table>

                  <table>
                    <div class="w-100" style="color: #000">
                      <div class="row no-gutters pb-1">
                        <div class="col-8 d-flex justify-content-evenly">
                          <div class="no-border mx-1">21-العمليات الجراحية</div>
                          <div class="no-border mr-2">
                            <div>أ-تاريخ اجرائها</div>
                            <div>ب- نوعها</div>
                            <div>ج-درجتها</div>
                          </div>
                        </div>
                        <div class="col-4 d-flex">
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </table>

                  <!-- end line 13-->
                  <!-- line 14 -->
                  <table>
                    <div class="w-100" style="color: #000">
                      <div class="row no-gutters">
                        <div class="col-8 d-flex justify-content-evenly">
                          <div class="no-border mx-1">صغرى</div>
                          <div class="no-border mx-2">متوسطة</div>
                          <div class="no-border mx-2">كبرى</div>
                          <div class="no-border mx-2">فوق الكبرى</div>
                          <div class="no-border mx-2">خاصة</div>
                        </div>

                        <div class="col-4 d-flex">
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </table>

                  <!-- end line 14 -->
                  <!-- line 15-->
                  <table>
                    <div class="w-100" style="color: #000">
                      <div class="row no-gutters py-1">
                        <div class="col-8 d-flex justify-content-evenly">
                          <div class="no-border mx-1">
                            22- حالة المريض بعد الخروج من المستشفى:
                          </div>
                          <div class="no-border mx-2 text-center">
                            <div>شفاء</div>
                            <div>تحسن</div>
                            <div>وفاة</div>
                          </div>
                          <div class="no-border mx-2">
                            <div>خرج على مسؤوليتة</div>
                            <div>نقل الى مسشتفى اخرى</div>
                            <div>حاله اخرى</div>
                          </div>
                        </div>
                        <div class="col-4 d-flex align-items-center">
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </table>

                  <!-- end line 15-->
                </b-col>
              </b-row>
              <!-- line 16 -->
              <b-row>
                <b-col class="" cols="1"></b-col>
                <b-col cols="11">
                  <table>
                    <div class="w-100" style="color: #000">
                      <div class="row no-gutters">
                        <div class="col-8 d-flex justify-content-evenly">
                          <div class="no-border mx-1">
                            23- مجموع الرقودات السابقة للمريض خلال السنة في هذه
                            المسشتفى :
                          </div>
                        </div>
                        <div class="col-4 d-flex">
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                          <div
                            style="width: 30px !important; height: 20px"
                            class="square-dark border border-2 border-dark"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </table>

                  <!-- end line 16 -->
                  <!-- line 17 -->
                  <table style="color: #000">
                    <tr class="pdf-table">
                      <th colspan="1" class="no-border">
                        اسم توقيع الممرضة المسؤولة
                      </th>
                      <th colspan="1" class="no-border">
                        اسم توقيع مسؤؤول الوحدة الطبية
                      </th>
                    </tr>
                  </table>
                  <!-- end line 17 -->
                </b-col>
              </b-row>

              <table style="border: none !important">
                <tr class="no-border">
                  <th colspan="1" class="no-border">ملاحظة</th>
                </tr>
                <tr class="no-border">
                  <th colspan="1" class="no-border">ملاحظة</th>
                </tr>
              </table>
            </b-col>
          </b-row>
        </table>
      </section>
    </vue-html2pdf>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BFormGroup,
  BFormSelect,
  BSpinner,
  BCardText,
  BInputGroup,
  BInputGroupAppend,
  BFormTextarea,
  BFormCheckbox,
} from "bootstrap-vue";
import vSelect from "vue-select";
import VueHtml2pdf from "vue-html2pdf";
import Datepicker from "vuejs-datepicker";

export default {
  components: {
    BCard,
    BFormCheckbox,
    BRow,
    BCol,
    BFormInput,
    BButton,
    vSelect,
    BFormGroup,
    BFormSelect,
    BSpinner,
    BCardText,
    BInputGroup,
    BInputGroupAppend,
    BFormTextarea,
    VueHtml2pdf,
    Datepicker,
  },

  data() {
    return {
      addForm: {
        name: "",
        age: "",
        history: "",
        companionName: "",
        adderss: "",
        occupation: "",
        gender: "",
      },
      errorForm: {
        name: "",
        age: "",
        history: "",
        companionName: "",
        adderss: "",
        occupation: "",
        gender: "",
      },
      genderOption: ["Male", "Female"],
      maritalStatusOptions: [
        "Single",
        "Married",
        "Divorced",
        "Widowed",
        "Seperated",
      ],
      residenceOptions: ["City", "Countryside"],
      patientStatusOptions: [
        "شفاء تام",
        "تحسن",
        "خرج على مسؤوليتة",
        "وفاة",
        "نقل الى مستشفى اخرى",
        "حالة اخرى",
      ],
      operationDegree: ["كبرى", "صغرى", " متوسطة", "فوق الكبرى", " خاصة"],
    };
  },
  methods: {
    printCurrentPatientForm() {
      this.$refs.currentPatientPdf.generatePdf();
    },
    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("-");
    },
  },
};
</script>
<style scoped>
.mb-md-0 {
  margin-top: 8px;
}

.start-box {
  display: flex;
  flex-direction: column;
  align-items: start;
  margin: 0 1rem;
  position: absolute;
  right: 1%;
  top: -13.5%;
}

table {
  width: 94%;
  border: 1px solid;
  font-size: 11px;
}

.no-border {
  border: 0;
}

.square-dark {
  background-color: rgba(0, 0, 0, 0.2);
}

tr,
th,
td {
  border: 1px solid;
  width: 10px;
  height: 10px;
  text-align: center;
}

.font-modify {
  letter-spacing: normal !important;
}

.pdf-table {
  page-break-inside: avoid;
}

.square {
  width: 30px;
  /* Smaller width for squares */
  height: 30px;
  /* Smaller height for squares */
  background-color: #000;
  /* Color of the square */
  display: inline-block;
  /* Allows us to set width and height */
}

.centered-text {
  text-align: center;
  border: 2px solid #000;
  /* Border for the cell */
}

#table-above {
  border-collapse: collapse;
  /* Removes space between borders */
  font-size: 12px;
  /* Smaller font size for the entire table */
}

@media print {
  @page {
  }

  .pdf-table {
    page-break-before: avoid;
    page-break-inside: avoid;
  }
}

.pdf-table:first-child {
  margin-top: 1em;
  /* Adjust the value as needed */
  page-break-inside: avoid;
}
</style>
